module.exports = __webpack_public_path__ + "static/media/costar_group.392e61ab.png";